(function () {
  'use strict';

  var STORAGE_KEY = 'marbenio_atelier_measurements';
  var COOKIE_KEY = 'marbenio_atelier_used';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
  var syncing = false;

  function readStorage() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* ignore quota */
    }

    try {
      document.cookie =
        COOKIE_KEY +
        '=1; path=/; max-age=' +
        COOKIE_MAX_AGE +
        '; SameSite=Lax' +
        (location.protocol === 'https:' ? '; Secure' : '');
    } catch (e2) {
      /* ignore */
    }
  }

  function formatNote(height, weight, extra) {
    var parts = ['Height: ' + height + 'cm', 'Weight: ' + weight + 'kg'];
    if (extra && extra.recommendedSize) {
      parts.push('Recommended size: ' + extra.recommendedSize);
    }
    if (extra && extra.composite && extra.composite.length) {
      parts.push(
        'Curated fit: ' +
          extra.composite
            .map(function (piece) {
              return piece.label + ' ' + piece.size;
            })
            .join(', ')
      );
    }
    if (extra && extra.source === 'find_my_size') {
      parts.push('Source: Find My Size');
    }
    if (extra && extra.source === 'cart_atelier') {
      parts.push('Source: Cart Atelier Confirm');
    }
    return 'Marbenio Atelier Fit — ' + parts.join(' · ');
  }

  function syncCartAttributes(payload) {
    if (!payload || !payload.height || !payload.weight) return Promise.resolve(false);

    var attributes = {
      _marbenio_atelier_used: 'yes',
      _marbenio_height: String(payload.height) + 'cm',
      _marbenio_weight: String(payload.weight) + 'kg',
      _marbenio_atelier_note: formatNote(payload.height, payload.weight, payload),
    };

    if (payload.recommendedSize) {
      attributes._marbenio_recommended_size = payload.recommendedSize;
    }
    if (payload.source) {
      attributes._marbenio_atelier_source = payload.source;
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (response) {
        return response.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function persistMeasurements(height, weight, extra) {
    var payload = {
      height: Number(height),
      weight: Number(weight),
      usedAssistant: true,
      recommendedSize: (extra && extra.recommendedSize) || null,
      composite: (extra && extra.composite) || null,
      source: (extra && extra.source) || 'find_my_size',
      ts: Date.now(),
    };

    writeStorage(payload);
    return syncCartAttributes(payload);
  }

  function confirmAtelierFit(height, weight, extra) {
    return persistMeasurements(height, weight, {
      recommendedSize: (extra && extra.recommendedSize) || null,
      composite: (extra && extra.composite) || null,
      source: 'cart_atelier',
    });
  }

  function wasAssistantUsed() {
    var stored = readStorage();
    if (stored && stored.usedAssistant) return true;

    try {
      return document.cookie.indexOf(COOKIE_KEY + '=1') !== -1;
    } catch (e) {
      return false;
    }
  }

  function resolveCheckoutForm(trigger) {
    if (trigger && trigger.form) return trigger.form;
    var formId = trigger && trigger.getAttribute('form');
    if (formId) return document.getElementById(formId);
    return trigger ? trigger.closest('form') : null;
  }

  function continueCheckout(trigger, form) {
    if (form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(trigger || undefined);
      } else {
        form.submit();
      }
      return;
    }

    if (trigger && trigger.href) {
      window.location.assign(trigger.href);
    }
  }

  function bindCheckoutSync() {
    document.addEventListener(
      'click',
      function (event) {
        if (syncing) return;

        var target = event.target;
        if (!target || !target.closest) return;

        var checkoutTrigger = target.closest(
          '[name="checkout"], #checkout, .cart__checkout-button, #CartDrawer-Checkout, a[href*="/checkout"]'
        );
        if (!checkoutTrigger || checkoutTrigger.disabled) return;

        var stored = readStorage();
        if (!stored || !stored.height || !stored.weight) return;

        event.preventDefault();
        event.stopPropagation();

        syncing = true;
        var form = resolveCheckoutForm(checkoutTrigger);

        syncCartAttributes(stored).finally(function () {
          syncing = false;
          continueCheckout(checkoutTrigger, form);
        });
      },
      true
    );
  }

  window.MarbenioAtelierBridge = {
    STORAGE_KEY: STORAGE_KEY,
    read: readStorage,
    persist: persistMeasurements,
    confirm: confirmAtelierFit,
    syncCart: syncCartAttributes,
    wasUsed: wasAssistantUsed,
    formatNote: formatNote,
  };

  bindCheckoutSync();
})();
